var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('svg',{class:("icon icon--" + _vm.name)},[_c('use',{attrs:{"href":("#icon-" + _vm.name)}})]),_vm._v(" "),(_vm.label)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }